<template>
  <a class="cta-round cta-icon" :class="{orange: theme == 'orange', blue: theme == 'blue'}" :href="href" :target="targetBlank ? '_blank' : '_self'">
    {{text}}
    <img src="@/assets/img/icons.svg#icon-external-link-white" width="14" height="14">
  </a>
</template>

<script>
  export default {
    name: "RoundButtonIcon",
    props: ['text', 'theme', 'href', 'targetBlank']
  }
</script>

<style lang="scss">
  .cta-icon {
    display: flex;
    align-items: center;

    img {
      margin-left: rem(10px);
    }
  }

</style>
